import { create } from "zustand";
import type { Problem } from "../api/types";

export interface ProblemEntry extends Problem {
  file: string;
}

interface ProblemsState {
  byFile: Record<string, Problem[]>;
  setProblems: (file: string, problems: Problem[]) => void;
  clear: (file?: string) => void;
  /** Set by the Trigger screen so the Problems dock can jump to a line. */
  jump: ((file: string, line: number, col: number) => void) | null;
  setJump: (fn: ProblemsState["jump"]) => void;
}

export const useProblems = create<ProblemsState>()((set, get) => ({
  byFile: {},
  setProblems: (file, problems) => set({ byFile: { ...get().byFile, [file]: problems } }),
  clear: (file) => {
    if (!file) return set({ byFile: {} });
    const next = { ...get().byFile };
    delete next[file];
    set({ byFile: next });
  },
  jump: null,
  setJump: (fn) => set({ jump: fn }),
}));

export function allProblems(byFile: Record<string, Problem[]>): ProblemEntry[] {
  return Object.entries(byFile).flatMap(([file, ps]) => ps.map((p) => ({ ...p, file })));
}
